var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bell-video"},[_vm._v(" Bell视频 敬请期待prpr ")])}
var staticRenderFns = []

export { render, staticRenderFns }